module.exports = __webpack_public_path__ + "media/ru_ru_s2_Katja.3c9c4591.oga";